import styled from "@emotion/styled";


export const Form = styled.form`
 
  padding: 20px;
  border-radius: 5px;
  width: 320px;
  height: 30vh;
`